import React, { useState } from "react";
import { FaBuilding, FaPersonBooth } from "react-icons/fa";
import Popup from "../../../../../../components/Popup";
import PopupReports from "../../../../../../components/PopupReports";
import formatterBR from "../../../../../../functions/formatCurrency";
import reportServices from "../../../../../../services/reportServices";
import { NewPaymentPopUp } from "./NewPaymentPopUp";

import "./styles.css";

export function PaymentsPopUp(props) {
    const [visibility, setVisibility] = useState(false);
    const [visibilityReport, setVisibilityReport] = useState(false);
    const payments = props.payments
    function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            reportServices.generateReportCollaboratorsPayments(payments, `RELATÓRIO DE PAGAMENTOS DO COLABORADOR ${props.name}`, fields, fileName);
        } catch (err) {
            alert(err.message);
            return false;
        }
    }
    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            tittle={"Pagamentos"}
            icon={<FaPersonBooth />}
        >
            <div className="records-element-info">
                {
                    payments.map((payment, key) => (
                        <div key={key}>
                            <p><b>Data Referente: </b>{payment.data_referente.split('-').reverse().join('/')}</p>
                            <p><b>Data do Pagamento: </b>{payment.data.split('-').reverse().join('/')}</p>
                            <p><b>Valor Pago: </b>{formatterBR.format(payment.valor_pago)}</p>
                            <div className="collaborator-payments-line"></div>
                        </div>
                    ))
                }
                <NewPaymentPopUp
                    visibility={visibility}
                    setVisibility={setVisibility}
                    id={props.id}
                    getPayments={props.getPayments}
                />
                <PopupReports
                    visibility={visibilityReport}
                    setVisibility={setVisibilityReport}
                    tittle={`Relatório de Pagamentos do Colaborador`}
                    fields={reportServices.collaboratorPaymentFields}
                    generateReport={generateReport}
                />
                <div className="collaborator-payments-buttons">
                    <button onClick={() => setVisibility(true)}>
                        Novo Pagamento
                    </button>
                    <button onClick={() => setVisibilityReport(true)}>
                        Imprimir Pagamentos
                    </button>
                </div>
                
            </div>
        </Popup>
    )
}